import { render } from "./vipDialog.vue?vue&type=template&id=5fd6ffb0&scoped=true"
import script from "./vipDialog.vue?vue&type=script&lang=js"
export * from "./vipDialog.vue?vue&type=script&lang=js"

import "./vipDialog.vue?vue&type=style&index=0&id=5fd6ffb0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd6ffb0"]])

export default __exports__